export const server = process.env.REACT_APP_SERVER_URL || "http://localhost:8000/api/v2";
export const backend_url = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000/";
export const socket_url = process.env.REACT_APP_SOCKET_URL || "http://localhost:4000";